<template>
  <div class="bg-white p-3 shadow">
    <h4 class="text-center">دسته بندی ها</h4>
    <hr>

    <m-categories-wrapper>
      <div slot-scope="{categories,flatCategories,setLinkType,clearRouter}">
        <m-a :href="clearRouter('blog')">
          <span class="m-1 rounded-pill btn-primary btn btn-sm ">{{
              latest
            }}</span>
        </m-a>
        <m-a v-for="category in categoryShape(categories)" :key="category.id" :href="setLinkType(category,linkType)"
             v-if="category.posts_count > 0">
          <span class="m-1 rounded-pill btn-primary btn btn-sm ">{{ category.name }}</span>
        </m-a>
      </div>
    </m-categories-wrapper>

  </div>
</template>

<script>
import {categoryPanelProps} from './CategoryPanelProps'
import {categoryMethods} from './CategoriesMethods'

export default {
  name: "CategoriesPanel300",
  props: categoryPanelProps,
  methods: categoryMethods,
}
</script>

<style scoped>

</style>